import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

export default function EditFAQ({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const addItem = () => set("items", [...(value.items || []), { question: "Nova pergunta", answer: "" }]);
  const removeItem = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Perguntas Frequentes">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="faq-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="faq-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="faq-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Perguntas</span>
            <ListAddBtn onClick={addItem} label="Adicionar pergunta" testId="faq-add-item" />
          </div>
          <div className="space-y-4">
            {(value.items || []).map((it, i) => (
              <div key={i} data-testid={`faq-row-${i}`} className="border border-border p-4 space-y-3">
                <Field label="Pergunta"><TextInput value={it.question} onChange={(v) => setItem(i, "question", v)} testId={`faq-question-${i}`} /></Field>
                <Field label="Resposta"><TextArea value={it.answer} onChange={(v) => setItem(i, "answer", v)} rows={3} testId={`faq-answer-${i}`} /></Field>
                <div className="flex justify-end"><ListRemoveBtn onClick={() => removeItem(i)} testId={`faq-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
